export default __webpack_public_path__ + "static/media/title_book.e844cf0c.webp";